import type { FC, ReactNode } from 'react'

interface MonogramProps {
    className?: string
}

// The AL mark: gold A, titanium L, on obsidian
export const Monogram: FC<MonogramProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' className={className} aria-hidden='true'>
            <rect width='64' height='64' rx='12' fill='#0a0c10' />
            <rect x='1.5' y='1.5' width='61' height='61' rx='10.5' fill='none' stroke='#ffd700' strokeOpacity='0.4' strokeWidth='1.5' />
            <path d='M11 46 L22 18 L33 46 M15.5 35 H28.5' fill='none' stroke='#ffd700' strokeWidth='5' strokeLinecap='square' />
            <path d='M40 18 V46 H54' fill='none' stroke='#8a95a5' strokeWidth='5' strokeLinecap='square' />
        </svg>
    )
}
